import { useStripeCheckoutResponse } from '@/hooks/billing/useStripeCheckoutResponse';
export const StripeCheckoutResponseHandler = () => {
  useStripeCheckoutResponse();
  return null;
};